import React, { useEffect } from 'react';

const SsoCallback: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const userRaw = params.get('user');
    const ssoError = params.get('sso_error');

    if (ssoError || !token || !userRaw) {
      window.location.replace(`/login?error=${encodeURIComponent(ssoError || 'sso_failed')}`);
      return;
    }

    try {
      const user = JSON.parse(decodeURIComponent(userRaw));
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      window.location.replace('/');
    } catch {
      window.location.replace('/login?error=sso_failed');
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600 text-sm font-medium">Completing sign-in...</p>
      </div>
    </div>
  );
};

export default SsoCallback;
